
<app-header *ngIf="loginDisplay"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="loginDisplay"></app-footer>
<!-- <app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer> -->